import React from "react"
import { useTranslation } from "react-i18next"

import { SelectOption } from "shared/types/Select"
import { InputContextType } from "shared/ui/input/Input"
import { Select } from "shared/ui/input/select/select/Select"

interface ProjectHistoryTimeFilterInputProps extends Partial<InputContextType> {
  options: SelectOption<number>[]
}

export const ProjectHistoryTimeFrameInput = React.memo(
  ({ options, ...rest }: ProjectHistoryTimeFilterInputProps) => {
    const { t } = useTranslation()
    return (
      <Select.Root
        name="timeFrame"
        label={t("ProjectHistory.Filter.TimeFrame")}
        className="project-history-filter__time-frame"
        {...rest}
      >
        <Select.Label />
        <Select.Input options={options} />
      </Select.Root>
    )
  }
)
